import fetch from 'services/request';
import { IAddManUalGiftCardBody, IGetGiftCardDetail, IGetListGiftCard } from './types/api';

const baseURL = 'api/v1/gift-card';

export const getListGiftCard = (params: IGetListGiftCard) => {
  return fetch({
    method: 'get',
    url: `${baseURL}/list`,
    params
  });
};
export const getGiftCardDetail = (params: IGetGiftCardDetail) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/detail/${params.id}`,
  });
};

export const resetGiftCardDetail = (body: string[]) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/reset`,
    body
  });
};

export const getSummaryGiftCards = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/gift-card/summary',
  });
};
const addManualGiftCard = (body: IAddManUalGiftCardBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/gift-card/add-manual',
    body
  });
};

export const deleteGiftCard = (id: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/gift-card/delete/${id}`,
  });
};

/**
 * TODO:
 * please replace giftCards to your feature name
 * ex:
 * giftCardsApis => bookingApis
 */
const giftCardsApis = {
  getListGiftCard,
  getGiftCardDetail,
  resetGiftCardDetail,
  getSummaryGiftCards,
  addManualGiftCard,
  deleteGiftCard,
};

export default giftCardsApis;
